import './index.less';
import { STATIC_FILE_URL, WEBSITE_URL } from '@/shared/constants';
import { ArrowRight } from '@/components/Common/Icons';
import Link from 'next/link';

const MembershipCards = () => {
  const cards = [
    {
      title: 'Explore product factories',
      description: 'Browse 1300+ product factories',
      bgSrc: `${STATIC_FILE_URL}/d8579d42489ce526517760f6d1bde9a0.png`,
      href: `/sourcing?tab=Products`,
      btnBgColor: '#A44658',
    },
    {
      title: 'Explore packaging factories',
      description: 'Browse poly mailers, boxes, and more',
      bgSrc: `${STATIC_FILE_URL}/8db5aad7085706443166ce8c58fd8080.png`,
      href: `/sourcing?tab=Ecommerce_Packaging&option=Get+in+8-10+days`,
      btnBgColor: '#CA4933',
    },
    {
      title: 'Explore freelancers',
      description: 'Browse logo designers, web devs, and more',
      bgSrc: `${STATIC_FILE_URL}/a224aaf63b8f735db3512d6ea45913a2.png`,
      href: `/sourcing?tab=Business_%26_Creative_Services`,
      btnBgColor: '#B172E4',
    },
  ];

  return (
    <div className="membership-cards-wrap">
      <div className="title">Your Pietra membership gives you access to</div>
      <div className="cards-wrap">
        {cards.map((card, index) => (
          <Link key={index} className="card-item-wrap" href={card.href}>
            <div
              className="card-bg"
              style={{
                backgroundImage: `url(${card.bgSrc})`,
              }}
            ></div>
            <div className="card-content">
              <div className="card-title">{card.title}</div>
              <div className="card-description">{card.description}</div>
              <a
                href={card.href}
                className="card-btn"
                style={{
                  backgroundColor: card.btnBgColor,
                }}
              >
                See all <ArrowRight />
              </a>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
export default MembershipCards;
